import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-page',
  template: `
    <app-page-section padding="sm" headerBackground="right">
      <div class="grid grid-cols-1 items-center md:grid-cols-2">
        <div class="col-span-1 mt-12 md:mt-0">
          <div class="relative -left-8 -top-6 flex space-x-2">
            <div class="mt-2.5 h-px w-16 bg-secondary-500"></div>
            <i class="fal fa-phone"></i>
          </div>
          <h1 class="text-balance">Nous sommes à votre écoute !</h1>
          <p class="mt-6 text-pretty"
            >Contactez-nous pour plus de renseignements ou pour une démo de
            notre logiciel.</p
          >
          <div class="mt-8 flex flex-col space-y-6">
            <div>
              <a class="no-underline" href="mailto:contact@ercos.ch">
                <i class="fal fa-paper-plane mr-1"></i>
                contact&#64;ercos.ch
              </a>
            </div>
            <div>
              <a class="no-underline" href="tel:0215253060">
                <i class="fal fa-phone mr-1"></i>
                021 525 30 60
              </a>
            </div>
            <div>
              <a
                class="no-underline"
                href="https://www.ercos.ch"
                target="_blank"
              >
                <i class="fal fa-globe mr-1"></i>
                ercos.ch
              </a>
            </div>
          </div>
        </div>

        <div class="col-span-1">
          <img
            class="mx-auto xl:w-3/4"
            ngSrc="contact-hero.png"
            width="1398"
            height="1345"
            sizes="(max-width: 768px) 80vw, 25vw"
            alt="Nous contacter"
            title="Nous contacter"
          />
        </div>
      </div>
    </app-page-section>

    <app-page-section>
      <h2 class="text-center">Pour aller plus loin</h2>

      <div
        class="mx-auto mt-20 grid w-3/4 grid-cols-1 gap-28 lg:w-full lg:grid-cols-2 lg:gap-16"
      >
        <app-contact-card
          badgeText="tester"
          title="Créer un compte"
          image="creer-compte.webp"
          link="/auth/devenir-un-hote"
        ></app-contact-card>

        <app-contact-card
          badgeText="consulter"
          title="Annuaire location-salles.ch"
          image="annuaire.webp"
          link="/louer-salle"
        ></app-contact-card>
      </div>
    </app-page-section>
  `,
  styles: ``,
  standalone: false,
})
export class ContactPageComponent {}
